export default __webpack_public_path__ + "static/media/team-member-18.80091956.jpg";